/* ========================================================================
//	HEADER
======================================================================== */

var Header = Header || {};
Header = (function ($) {

    
//	CACHE
//	-----------------------------------------------------------------

	var

	$header = $('#header'),
	$btnMenu = $('#btnMenu'),

	$headerMenu = $header.find('.menu'),
    $menuHeaderContainer = $('#menuHeaderContainer'),
    
	$transitory1a = $header.find('.transitory1a'),
	$transitory1b = $header.find('.transitory1b'),
	$transitory2a = $header.find('.transitory2a'),
	$transitory2b = $header.find('.transitory2b'),
    
	// $menuBtns = $headerMenu.find('a'),
    
	isMobile = false,



//	RESIZE FUNCTION
//	-----------------------------------------------------------------

	headerResize =  function(_args){
		
		
		if (_args.winStepNum > 2){
			if($btnMenu.hasClass('on')){
				$btnMenu.removeClass('on');
				$menuHeaderContainer.scrollTop(0).removeClass('active');
			}
			$header.removeClass('mobile');
			if(isMobile){
				$transitory1b.children().detach().appendTo($transitory1a);
				$transitory2b.children().detach().appendTo($transitory2a);
				isMobile = false;
			}
		}
		else {
			$header.addClass('mobile');
			if(!isMobile){
				$transitory1a.children().detach().appendTo($transitory1b);
				$transitory2a.children().detach().appendTo($transitory2b);
				isMobile = true;
			}
		}
        
	},



//	INIT
//	-----------------------------------------------------------------

	init = function(_args){
        
        // console.log('\n/ commtrol / HEADER');
        
        MyTools.onWinResize({ func: headerResize });
		
		
		// BTN MENU
		MyTools.touch({ el: $btnMenu, deactivate: 500, funcDelay: 0, func: toggleMenu });
		function toggleMenu(){
			
			$('html').toggleClass('freeze');
			$btnMenu.toggleClass('on');
			$menuHeaderContainer.toggleClass('active').scrollTop(0);

			// DISMISS ALL SUBMENUS OPEN
			$('.menu.dismissable').find('.active').removeClass('active');
			$('.menu.dismissable').find('.hover').removeClass('hover');
			$('.menu.dismissable').find('.sub-menu-wrap').height(0);

			// $win.trigger('resize');
		};
		
	};
    init();

})(jQuery, MyTools);
